'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTime = function getTime() {
  return performance.now ? performance.now() : Date.now();
};

var scrollToTop = function scrollToTop() {
  var containerEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  var offsetTop = arguments[1];
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;

  var initialY = containerEl.scrollTop;
  var difference = offsetTop; // offsetTop - initialY;
  var startTime = getTime();

  function step() {
    var normalizedTime = (getTime() - startTime) / duration;
    if (normalizedTime > 1) normalizedTime = 1;

    containerEl.scrollTo(0, initialY + difference * Math.sin(normalizedTime * Math.PI / 2));
    if (normalizedTime < 1) window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
};

var scrollToFirstError = exports.scrollToFirstError = function scrollToFirstError() {
  var containerEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;

  var errorEl = containerEl.querySelector('.next-form-item.has-error');
  if (errorEl) {
    var offsetTop = errorEl.offsetTop;
    scrollToTop(containerEl, offsetTop);
  }
};

exports.default = scrollToTop;